import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20amber%20theater%20lighting%2C%20abstract%20film%20strip%20texture%20with%20soft%20bokeh%20effect%2C%20luxurious%20velvet%20curtain%20drapes%20in%20deep%20crimson%20and%20burgundy%20tones%2C%20elegant%20movie%20theater%20ambiance%20with%20warm%20spotlight%20glow%2C%20cinematic%20composition%20with%20rich%20contrast%20and%20atmospheric%20depth&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="看片网站精选推荐 - 高清影视资源导航"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto py-16 md:py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 font-heading leading-tight">
          看片网站精选推荐
        </h1>
        <p className="text-lg md:text-2xl text-white/90 mb-4 font-heading">
          高清免费资源一站直达
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          寻找优质看片网站？本页精选全网口碑最佳的看片网站，涵盖高清电影、热门剧集、综艺纪录片，无需注册即可在线观看，速度快、画质清晰、资源更新及时，帮你快速找到最适合的看片网站。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/latest-movies"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索推荐网站
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 text-white backdrop-blur-sm rounded-full font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 gap-4 md:gap-8 max-w-lg mx-auto">
          {[
            { value: '200+', label: '精选网站' },
            { value: '50万+', label: '月活跃用户' },
            { value: '98%', label: '用户满意度' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}